module.exports = __webpack_public_path__ + "img/pic1.afe7aa4c.png";